import { isPlatformServer } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { AlertType, CmsSalesOrgAlertMessageComponent } from '../../../../core/model';
import { AlertsService } from '../../base/services';

@Component({
  selector: 'py-sales-org-alert-message',
  templateUrl: './sales-org-alert-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SalesOrgAlertMessageComponent implements OnInit {
  title$: Observable<string>;
  body$: Observable<string>;
  type$: Observable<AlertType>;
  dismissable$: Observable<boolean>;
  showAlert$: Observable<boolean>;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: Object,
    private alertsService: AlertsService,
    private componentData: CmsComponentData<CmsSalesOrgAlertMessageComponent>
  ) {}

  ngOnInit(): void {
    const alert$ = this.componentData.data$.pipe(shareReplay({ bufferSize: 1, refCount: true }));

    const title$ = alert$.pipe(
      filter((data) => Boolean(data)),
      map((data) => data.header)
    );
    this.title$ = title$;

    this.body$ = alert$.pipe(
      filter((data) => Boolean(data)),
      map((data) => data.body)
    );

    const type$ = alert$.pipe(
      filter((data) => Boolean(data)),
      map((data) => {
        const alertTypeKey = Object.keys(AlertType).find((key) => AlertType[key] === data.alertType);
        return AlertType[alertTypeKey];
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.showAlert$ = combineLatest([type$, title$, alert$]).pipe(
      filter(([type, title, alert]) => !!title && !!type && !!alert),
      switchMap(([type, _, alert]) => {
        return this.alertsService.isAlertDismissed(type, alert.body);
      }),
      map((isDismissed) => !isDismissed && !isPlatformServer(this.platformId))
    );

    this.type$ = type$;
    this.dismissable$ = alert$.pipe(map((data) => data.dismissible === 'true'));
  }

  onAlertDismiss(type: AlertType, body: string): void {
    this.alertsService.dismissAlert(type, body);
  }
}
